import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import deleteDisabledIcon from '../../../images/Autocode/deleteDisabledIcon.svg';
import deleteHoverIcon from '../../../images/Autocode/deleteHoverIcon.svg';
import deleteActiveIcon from '../../../images/Autocode/deleteActiveIcon.svg';
import { useACGridContext } from '../ACContext/ACGridContext';

const AutocodeGridHeaders = props => {
  const { title, count, weightType, gridCategory } = props;
  const { deleteGrid } = useACGridContext();
  const deleteIcon = count === 0 ? deleteDisabledIcon : deleteHoverIcon;
  const [finalDeleteIcon, setFinalDeleteIcon] = useState(deleteIcon);

  useEffect(() => {
    const deleteIcon = count === 0 ? deleteDisabledIcon : deleteHoverIcon;
    setFinalDeleteIcon(deleteIcon);
  }, [count]);

  const generateIcon = e => {
    e.preventDefault();
    if (count > 0) {
      const newFinalDeleteIcon =
        finalDeleteIcon === deleteHoverIcon
          ? deleteActiveIcon
          : deleteHoverIcon;
      setFinalDeleteIcon(newFinalDeleteIcon);
    }
  };  
  return (
    <div className="grid-headers-container" data-test="AutocodeGridHeaders">
      <div className="grid-headers">
        <div className="grid-header">
          <div className="grid-main-title">
            <span className="grid-head-main">{title[0].name}&nbsp;&nbsp;</span>
            <span>{count}</span>
          </div>
          {/* <div className="grid-rowcount">5</div> */}
        </div>
        {title[1] ? (
          <Fragment>
            <div className="grid-header">{title[1].name}</div>
            <div className="grid-header">
              <span> {title[2].name}&nbsp;</span>
              <span>{weightType}</span>
            </div>{' '}
          </Fragment>
        ) : (
          ''
        )}
      </div>
      <div className="grid-delete-icon">
        <img
          src={finalDeleteIcon}
          onMouseOver={generateIcon}
          onMouseOut={generateIcon}
          onBlur={generateIcon}
          onFocus={generateIcon}
          alt="delete"
          onClick={() => {
            if (count && count > 0) {
              deleteGrid(gridCategory);
            }
          }}
        />
      </div>
    </div>
  );
};

AutocodeGridHeaders.propTypes = {
  title: PropTypes.arrayOf(PropTypes.object),
  count: PropTypes.number,
  weightType: PropTypes.string,
  gridCategory: PropTypes.string,
};

export default AutocodeGridHeaders;
